import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './EventCard.css';
import languageIcon from '../../assets/Book Events/vectors-13.png';

/**
 * Individual Event Card component
 * Displays event information in a card format with pricing and details
 */
const EventCard = ({ event, onShare }) => {
    const {
        event_id,
        category_label,
        title,
        description,
        keywords = [],
        language,
        pricing = [],
        image_url,
        background_icon,
        title_url
    } = event;

    const handleShare = (e) => {
        e.preventDefault();
        if (onShare) {
            onShare(event);
        }
    };

    const getEventUrl = () => {
        return `/event_details/${event_id}`;
    };

    return (
        <div className="event-card">
            <div className="event-card__container">
                {/* Background decorative icon/image */}
                {background_icon && (
                    <div className="event-card__background">
                        <img src={background_icon} alt="" aria-hidden="true" />
                    </div>
                )}

                {/* Share button */}
                <button 
                    className="event-card__share-btn" 
                    onClick={handleShare}
                    aria-label="Share event"
                >
                    <i className="fas fa-share-alt"></i>
                </button>

                {/* Category label */}
                {category_label && (
                    <div 
                        className={`event-card__category ${
                            category_label.toLowerCase().includes('newly wed') || category_label.toLowerCase().includes('newlywed')
                                ? 'event-card__category--blue'
                                : category_label.toLowerCase().includes('birth') || category_label.toLowerCase().includes('upto')
                                ? 'event-card__category--pink'
                                : ''
                        }`}
                    >
                        {category_label}
                    </div>
                )}

                {/* Event Title */}
                <h3 className="event-card__title">
                    <Link to={getEventUrl()}>{title}</Link>
                </h3>

                {/* Description */}
                {description && (
                    <p className="event-card__description">
                        {description}
                    </p>
                )}

                {/* Keywords/Tags */}
                {keywords && keywords.length > 0 && (
                    <div className="event-card__keywords">
                        {keywords.map((keyword, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <span className="event-card__keyword-separator"> | </span>}
                                <span className="event-card__keyword">{keyword}</span>
                            </React.Fragment>
                        ))}
                    </div>
                )}

                {/* Language indicator */}
                {language && (
                    <div className="event-card__language">
                        <img 
                            src={languageIcon} 
                            alt="" 
                            className="event-card__language-icon"
                            aria-hidden="true"
                        />
                        <span className="event-card__language-text">Language: {language}</span>
                    </div>
                )}

                {/* Pricing */}
                {pricing && pricing.length > 0 && (
                    <div className="event-card__pricing">
                        {pricing.map((price, index) => (
                            <div key={index} className="event-card__price-item">
                                <span className="event-card__price-amount">INR {price.amount}/-</span>
                                <span className="event-card__price-label"> per {price.label}</span>
                            </div>
                        ))}
                    </div>
                )}

                {/* Know More button */}
                <div className="event-card__footer">
                    <Link to={getEventUrl()} className="event-card__btn">
                        Know More
                    </Link>
                </div>
            </div>
        </div>
    );
};

EventCard.propTypes = {
    event: PropTypes.shape({
        event_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        category_label: PropTypes.string,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        keywords: PropTypes.arrayOf(PropTypes.string),
        language: PropTypes.string,
        pricing: PropTypes.arrayOf(
            PropTypes.shape({
                amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                label: PropTypes.string
            })
        ),
        image_url: PropTypes.string,
        background_icon: PropTypes.string,
        title_url: PropTypes.string
    }).isRequired,
    onShare: PropTypes.func
};

export default EventCard;

